import { Form } from 'antd';
import styled from '@emotion/styled';

const FormItem = styled(Form.Item)`
  label {
    font-weight: 400;
    line-height: 16px;
    font-size: 12px;
    letter-spacing: 0.005em;
    color: #232b3a;
  }
`;

export default FormItem;
